import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseResizableComponent } from '@src/app/modules/base';
import { CitySwitcherItemType } from '@src/app/modules/search-cities';

@Component({
  selector: 'lp-collection-new-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LpCollectionNewHeaderComponent extends BaseResizableComponent {
  @Input() city?: CitySwitcherItemType;
  @Output() cityChange = new EventEmitter<CitySwitcherItemType>();

  dropdownOpen = false;
}
